import { isString as n } from "@ddg-frontend/fe-essentials";
const e = (o, t) => {
  if (!n(o))
    return;
  const r = o.trim(), i = r.startsWith("#");
  if (t === "style")
    return i ? {
      backgroundColor: r
    } : {};
  if (t === "class" && !i)
    return r;
};
export {
  e as parseBackgroundColor
};
